import { getCountries, getCountryByName } from 'node-countries';

// https://www.npmjs.com/package/node-countries
// returns the list of provinces of a country
// works with both full name and short name
// enhanced by node-countries

type Country = {
  id: string;
  name: string;
};

type Province = {
  id: string;
  name: string;
};

export const getCountriesAll = (): Country[] => {
  return getCountries().map((c) => ({ id: c.alpha2, name: c.name }));
};

export const getProvincesByName = (country: string): Province[] => {
  return getCountryByName(country, true)?.provinces?.map((p) => ({ id: p.short ?? '', name: p.name })) ?? [];
};
